<template>
    <div class="container" style="margin-top: 50px">
        <div id="hs_root"></div>
    </div>
</template>

<script>
    export default {
        name: "HsOrder",
        created(){
            window._hs = {lng: "", usr: "sOORq5rylFuuUuOl"};

            var hsa = document.createElement("script"); hsa.type = "text/javascript"; hsa.async = true;
            hsa.src = "https://hotelsystem.hu/api/order/js.php?_="+Math.random();
            var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(hsa, s);
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// HsOrder.vue?6438ddef